import uploadshomesidebyside01bgimageshutterstock_2611517511Jpg from "$lib/data/generated/uploads/home/SideBySide 01/bgImage/shutterstock_2611517511.jpg";
import uploadshomesidebyside01imageimg_2571Lightfix842x1100Jpg from "$lib/data/generated/uploads/home/SideBySide 01/image/IMG_2571-lightfix-842x1100.jpg";

export const uploads = {
  "uploads/home/SideBySide 01/bgImage/shutterstock_2611517511.jpg": uploadshomesidebyside01bgimageshutterstock_2611517511Jpg,
  "uploads/home/SideBySide 01/image/IMG_2571-lightfix-842x1100.jpg": uploadshomesidebyside01imageimg_2571Lightfix842x1100Jpg
};